import { render, staticRenderFns } from "./NotificationContactForm.vue?vue&type=template&id=66f53860&scoped=true&"
import script from "./NotificationContactForm.vue?vue&type=script&lang=ts&"
export * from "./NotificationContactForm.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContactForm.vue?vue&type=style&index=0&id=66f53860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f53860",
  null
  
)

export default component.exports